<template>
  <div class="suggest-replace-part">
    <!-- 接口暂时未完成 -->
    <div class="item-title">{{$t('asm_suggest_replace_part.xtjyghlj')}}</div>
    <div class="table-bd">
      <custom-table
        max-height="400px"
        :data="tableList"
        :tableCode="tableCode"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
        :filterArr="['action']"
      >
      </custom-table>
    </div>
  </div>
</template>

<script>
/**
 * 建议更换零件
 */
import apis from '@/utils/apis';

export default {
  name: '',
  inject: ['getCaseInfo'],
  mixins: [],
  components: {},
  props: {
    productCode: [Number, String],
    bodyNum: [Number, String]
  },
  data() {
    return {
      tableCode: 'sys_suggest_replace_part',
      tableList: [],
    };
  },
  computed: {
    info() {
      return this.getCaseInfo();
    }
  },
  watch: {
    info: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getTableList();
        }
      }
    }
  },
  filters: {},
  directives: {},
  methods: {
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      this.$getJSON(apis.caseOrderPartSysList, {
        productCode: this.info.productCode,
        bodyNum: this.info.bodyNum
      }).then((res) => {
        this.tableList = res.data || [];
      });
    },
  },
  created() { },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.suggest-replace-part {
  padding: 16px;
}
</style>
